<div class="container-fluid">
    <div class="row">
        <div class="col">
            <nav
                class="navbar navbar-expand px-0 py-2 w-100 justify-content-between align-items-center d-block d-md-flex"
            >
                <img src="../../../../../assets/images/thw_logo_stars.png" class="clickable thw-logo" routerLink="/">
                <ul class="navbar-nav text-dark justify-content-center justify-content-md-end d-block d-md-flex">
                    <li class="nav-item">
                        <a
                            href="https://thw-handball.de/impressum/"
                            routerLinkActive="nav-link--active"
                            class="nav-link text-center clickable"
                        >
                            {{ 'legal-notice.legal-notice' | translate }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a
                            href="https://thw-handball.de/service/datenschutz/"
                            routerLinkActive="nav-link--active"
                            class="nav-link text-center clickable"
                        >
                            {{ 'privacy-policy.privacy-policy' | translate }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a
                            href="https://thw-handball.de/kontakt/"
                            routerLinkActive="nav-link--active"
                            class="nav-link text-center clickable"
                        >
                            {{ 'contact.contact' | translate }}
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</div>
